import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { StoryblokImage } from "@wojo/storyblok";
import { Button, Text } from "@wojo/ui";
import { useState } from "react";
import { useTourPageContext } from "../../_client/context";
import style from "./TourHeroSummaryInfo.module.scss";
import { TourHeroSummaryInfoModal } from "./TourHeroSummaryInfoModal";

export const TourHeroActivityLevel: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { productPage } = useI18n("productPage");
    const { tourContent } = useTourPageContext();

    const activityLevel = tourContent.tour?.activityLevelContent;
    if (!activityLevel?.name) {
        return null;
    }
    return (
        <Text tag="dl" className={style["summary-info-detail-wrapper"]}>
            <Text tag="dt">
                {productPage.tourHero.heroSummary.activityLevel.l()}
            </Text>
            <Text tag="dd" className={style["summary-info-detail"]}>
                <Button
                    variant="quiet"
                    onClick={() => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_action: "OPENED",
                                ga4_object: "MODAL",
                                modalId: "Tour Activity Level",
                            },
                        });
                        setIsModalOpen(true);
                    }}
                    adornLeft={
                        !!activityLevel.icon?.filename && (
                            <StoryblokImage
                                mobile={{
                                    asset: activityLevel.icon,
                                }}
                                style={{
                                    height: "16px",
                                    display: "grid",
                                }}
                            />
                        )
                    }
                >
                    {activityLevel.name}
                </Button>
            </Text>
            <TourHeroSummaryInfoModal
                onCloseRequested={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_action: "CLOSED",
                            ga4_object: "MODAL",
                            modalId: "Tour Activity Level",
                        },
                    });
                    setIsModalOpen(false);
                }}
                isOpen={isModalOpen}
                icon={activityLevel.icon}
                iconWidth="24px"
                heading={activityLevel.name}
                description={activityLevel.description ?? ""}
                accessibleTitle={productPage.tourHero.titles.activityLevel.l()}
            />
        </Text>
    );
};
